<script setup lang="ts">
  defineOptions({ name: 'AppSidebarGroup' })

  import CPText from '@ui/components/CPText.vue'

  import { twMerge } from 'tailwind-merge'

  defineProps({
    header: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
  })
</script>

<template>
  <!--
    NOTE: No `id` on this root — `AppSidebarGroup` is mounted multiple times per page (e.g. MembersSidebar
    renders two instances). A fixed `id` would create duplicate DOM IDs, breaking accessibility and ambiguating
    CSS/E2E selectors. Consumers that need to target a specific group from E2E should use the
    `.app-sidebar-group` class plus a `.filter({ has: <unique-child-locator> })` clause (see
    contracts.spec.ts, shared-files.spec.ts, communities.spec.ts for the pattern).
  -->
  <div class="app-sidebar-group w-full relative">
    <div v-if="header || $slots.header" :class="twMerge(['pl-2 h-8 flex items-center sticky z-10 top-0 bg-sidebar mb-1', headerClass])">
      <slot name="header">
        <CPText size="sm" weight="medium" class="text-on-sidebar opacity-70 text-nowrap">
          {{ header }}
        </CPText>
      </slot>
    </div>
    <div class="w-full">
      <slot />
    </div>
  </div>
</template>
